import { Route } from '~/Constants/Routes.constants';

export enum AccessList {
  RECEIVE_LIVE_STREAM_REMINDER,
  RECEIVE_CONTRACT_CANCELLATION,
  USER_NOTIFICATIONS,
  RECEIVE_CHECKOUT_EMAIL,
  HIDE_USC_LOCATION_WARNING_PARTNER_TOOL,
  SWITCH_INTERFACE,
  HELP_CENTER_LINK,
  SUPPORT_LINK,
  CHECKLIST,
  SEND_EMAIL_ON_EVENT_CANCEL,
  USC_SYNC_STATUS,
  WAITING_LIST,
  MANUAL_BOOKING,
  EDIT_EVENT_MENU,
  ONLY_FREE_TRAINING,
  SCHEDULE_RECURRENCE_TIME_INTERVAL,
  SCHEDULE_RECURRENCE_MONTHLY,
  FORCE_EVENT_GROUP_USC_SYNC,
  BOOKING_RESTRICTION_ENTRY,
  EVENT_GROUP_FILTER_CATEGORIES,
  TRAINER_FILTER,
  CUSTOMER_PROFILE,
  CANCELLATION_LIST,
  CHECKIN_PP_STATUS,
  GLOBAL_SEARCH,
  TEXT_AS_KEYS,
  CANCELATION_WINDOW_PARTNER_TOOL,
  HIDE_SPORTS_CATEGORY_WARNING_PARTNER_TOOL,
  EDIT_FREE_TRAINING,
  STAFF_MENU,
  EDIT_SCHEDULE_WITH_BOOKINGS,
  SHOW_TRAINER_WARNING,
  SHOW_BOOKED_EVENT_SCHEDULE_EDIT_WARNING,
  BOOKING_TOOL_INTEGRATION,
  HIDDEN_FREE_TRAINING,
  ADD_PROVIDER,
  SEE_STUDIO_TYPE_ICON_ON_PROVIDER_SELECT,
  CAN_UPLOAD_EVENT_IMAGE,
  DASHBOARD_STUDIO_STATUS,
  SET_ORGANISATION_MANAGER,
  SHOW_MANAGE_BOOKINGS_BUTTON,
  EVENT_CATEGORIES,
  SPORTS_CATEGORY_TOOLTIP,
  MINIMAL_EVENT_GROUP_DESCRIPTION_EDITOR,
  LOCATION_WELCOME_PACKAGE,
  COPY_LOCATION,
  TEXT_DESCRIPTION_FOR_LOCATION,
  GLOBAL_WARNING,
  NEWSROOM,
  PARTNER_SERVICES,
  VENUEID_IN_MENU,
  CHANGE_OWNERSHIP,
  CREATE_MERCHANT,
  DEFAULT_CANCELATION_WINDOW,
  FIRST_FREE_CHECKIN,
  ORGANISATION_STAFF_NAME_TOGGLE,
  EXPORT_PAGE,
}

export enum AccessRoles {
  TRAINER,
  RESTRICTED,
  FULL_ACCESS,
  FITOGRAM_SUPER_ADMIN,
  PARTNER_TOOL_ADMIN,
  NO_ACCESS,
  ORGANISATION_MANAGER,
}

export enum FitogramVersion {
  Neo,
  PartnerTool,
}

export type AccessListItem =
  | {
      names: AccessList[];
      accessToOneOf: AccessRoles[];
      fitogramVersion: FitogramVersion[];
    }
  | {
      names: Route[];
      accessToOneOf: AccessRoles[];
      fitogramVersion: FitogramVersion[];
    };
